module.exports = __webpack_public_path__ + "img/www.amazon.com.17a41544.png";